import script from "./WheelSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./WheelSelector.vue?vue&type=script&setup=true&lang=js"

import "./WheelSelector.vue?vue&type=style&index=0&id=19dce5c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19dce5c4"]])

export default __exports__